import * as React from "react";
import { useStore } from "../../App";
import { observer } from "mobx-react";
import { GeoJSONLayer, MapContext } from "react-mapbox-gl";
import HoverFeatures from "./HoverFeatures";
import { styled } from "../../ui/theme";
import { Heading } from "@chakra-ui/core";

export default observer(function KaartData() {
  const [hoverFeature, _hoverFeature] = React.useState(null);
  const store = useStore();

  //console.log(store.paintInterpolate);
  const { fillPaint, symbolLayout, symbolPaint } = store.paint.paints;

  return (
    <>
      <GeoJSONLayer
        id="bla"
        data={store.geoJSON}
        symbolLayout={symbolLayout}
        symbolPaint={symbolPaint}
        fillPaint={fillPaint}
        fillOnClick={e => {
          let f = e.features[0];
          let t = f.properties.type;
          if (t === "v") {
            store.setActiveRegioById(f.properties.id);
          } else if (t === "p") {
            store.setActiveProvincieById(f.properties.id);
          } else {
            store.setActiveGemeenteById(f.properties.id);
          }
        }}
      />
      <HoverFeatures
        layerId="bla-fill"
        onHover={f => {
          _hoverFeature(f);
        }}
      />

      {store.activeBase !== null && <GeoJSONLayer data={store.activeBase.geoJSON} linePaint={activePaint} />}
      {hoverFeature !== null && (
        <InfoBox>
          <Heading size="sm" color="white">
            {hoverFeature.properties.name}
          </Heading>
          <p>Opgenomen patiënten: {hoverFeature.properties.total}</p>
          <p>Toename: {hoverFeature.properties.delta}</p>
          <p>Per 100k: {hoverFeature.properties.total100k}</p>
          <p>Toename Per 100k: {hoverFeature.properties.delta100k}</p>
        </InfoBox>
      )}
    </>
  );
});

const activePaint = {
  "line-color": "#3BC9DB",
  "line-width": 6,
  "line-opacity": 0.4
};

const InfoBox = styled.div`
  border-radius: 8px;
  background-color: black;
  padding: 16px;

  position: absolute;
  right: 16px;
  top: 48px;
  color: #fff;

  pointer-events: none;

  p {
    pointer-events: none;
  }
`;
